<template>
  <section>
    <section :class="($mq.phone) ? 'bg-white py-4' : 'bg-gray'">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-12">
          <div :class="{'card py-3 shadow-sm': !$mq.phone}">
            <div :class="{'card-body': !$mq.phone}">

              <!-- Form Step 1 -->
              <section v-if="step === 1">
                <div class="row">
                  <div class="col">
                    <h2 class="mb-3">{{ $t('message.service_request.service_request_notification') }}</h2>

                    <div class="">
                      <h3>
                        {{ $t('message.booking.booking_step.service') }}: <span v-html="$options.filters.serviceParentName(submitData.service_id, globalState.services)"></span>
                      </h3>
                    </div>

                    <!-- Experience section -->
                    <div class="pb-2" v-if="experience && experience.service && Number(experience.service.is_service_request) === 1">
                      <div class="card shadow-sm">
                        <div class="card-body">
                          <div class="d-flex">
                            <div>
                              <div class="img-selected-experience rounded-all">
                                <img :src="experience.cover_photo" class="img-experience-photo" alt="">
                              </div>
                            </div>
                            <div class="pl-3">
                              <strong>
                                <span v-html="$options.filters.shortText(experience.title, 100)"></span>
                              </strong>
                              <div class="text-small text-secondary pt-2" v-if="Number(experience.avg_rating) > 0">
                                <i class="fas fa-star -rating-star mr-0"></i> {{ Number(experience.avg_rating).toFixed(1) }}
                                ·
                                {{ experience.num_rating }} {{ $tc('message.professional.review', experience.num_rating) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
                <!-- Service purpose -->
                <div class="row pb-3" v-if="submitData.service_id === 13 || submitData.service_id === 49">
                  <div class="col-12">
                    <h4 class="pb-2">{{ $t('message.service_request.big_cleaning_purpose') }}</h4>
                    <div class="select-jumbo">
                      <select v-model="submitData.service_request_purpose_id">
                        <template v-for="data in serviceRequestPurposes">
                          <option :value="data.id">{{ data | multiLangName }}</option>
                        </template>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- Service date -->
                <div class="row py-3">
                  <div class="col-12">
                    <h4 class="pb-2">{{ $t('message.service_request.big_cleaning_service_date') }}</h4>
                  </div>
                  <div class="col-6 pr-0">
                    <div class="mr-2">
                      <input type="text"
                             name="serviceDate"
                             :placeholder="$i18n.t('message.booking.booking_step.date')"
                             class="form-control -date-picker input-jumbo"
                             v-pikadayBooking="calendarData"
                             ref="cleaningDate"
                             readonly
                             v-validate="'required'"/>
                      <span class="far fa-calendar-alt input-text-icon"></span>
                      <div class="mt-2 text-remark -status-alert" v-if="errors.has('serviceDate')">
                        {{ $t('message.required_field') }}
                      </div>
                    </div>
                  </div>
                  <div class="col-6 pl-0">
                    <div class="ml-2">
                      <div class="select-jumbo">
                        <select style="background: white;" v-model="submitData.service_time">
                          <option :value="time" v-for="time in globalState.arrTimes">{{ time }}</option>
                        </select>
                        <span class="far fa-clock input-text-icon"></span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Building type -->
                <div class="row py-3" v-if="displayBuildingType">
                  <div class="col-12">
                    <h4 class="pb-2">{{ $t('message.service_request.big_cleaning_building_type') }}</h4>
                    <div class="select-jumbo">
                      <select v-model="submitData.building_type_id">
                        <template v-for="data in globalState.configData.building_types">
                          <option :value="data.id">{{ data | multiLangName }}</option>
                        </template>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- Building size -->
                <div class="row py-3">
                  <div class="col-12">
                    <h4>
                      {{ (submitData.service_id === 49) ? $t('message.service_request.upholstery_cleaning_size') : $t('message.service_request.big_cleaning_building_size') }}
                    </h4>
                    <div class="text-remark mb-2">
                      <i class="fas fa-circle fa-xs -status-pending"></i>&nbsp;{{ (submitData.service_id === 49) ? $t('message.service_request.upholstery_cleaning_size_remark') : $t('message.service_request.big_cleaning_building_size_remark') }}
                    </div>
                    <textarea
                          class="form-control"
                           name="buildingSize"
                           id="buildingSize"
                           :placeholder="(submitData.service_id === 49) ? $i18n.t('message.service_request.upholstery_cleaning_size_placeholder') : $i18n.t('message.service_request.big_cleaning_building_size_placeholder')"
                           v-model="submitData.building_size"
                           :class="{'form-alert': errors.has('buildingSize')}"
                           v-validate="'required'">
                    </textarea>
                    <div class="mt-2 text-remark -status-alert" v-if="errors.has('buildingSize')">
                      {{ $t('message.required_field') }}
                    </div>
                  </div>
                </div>

                <div class="row pt-3">
                  <div class="col">
                    <button class="btn btn-lg btn-info btn-block -cyan" @click="nextStep()">
                      {{ $t('message.booking.new_booking.continue') }}
                    </button>
                  </div>
                </div>

                <div class="text-center pt-3" v-if="isLineLoggedIn">
                  <router-link to="/line-liff">
                    <i class="fas fa-angle-left"></i> {{ $t('message.booking.new_booking.back') }}
                  </router-link>
                </div>
              </section>
              <!-- End form Step 1 -->

              <!-- Form Step 2 -->
              <section v-else-if="step === 2">
                <!-- Phone -->
                <div class="row py-3">
                  <div class="col">
                    <h4 class="pb-2">{{ $t('message.service_request.big_cleaning_building_address') }}</h4>
                    <label for="tel">{{ $t('message.booking.contact_step.phone') }}<span class="text-danger">*</span></label>
                    <input type="tel"
                           class="form-control input-jumbo"
                           :class="{'form-alert': errors.has('tel')}"
                           id="tel"
                           name="tel"
                           ref="tel"
                           v-model="submitData.tel"
                           v-validate="{ required: true, min: 10, max: 15, regex: /^\+?[0-9-]+$/ }">
                    <div class="mt-1 text-remark -status-alert" v-if="errors.has('tel')">
                      {{ $t('message.required_field') }}
                    </div>
                  </div>
                </div>

                <!-- Building address -->
                <div class="row">
                  <div class="col">
                    <label for="address">{{ $t('message.booking.contact_step.address') }} - {{
                        $t('message.booking.contact_step.address_remark') }}<span class="text-danger">*</span></label>
                    <input type="text"
                           class="form-control input-jumbo"
                           :class="{'form-alert': errors.has('address')}"
                           id="address"
                           name="address"
                           ref="address"
                           v-model="submitData.building_address"
                           v-validate="'required'">
                    <div class="mt-1 text-remark -status-alert" v-if="errors.has('address')">
                      {{ $t('message.required_field') }}
                    </div>
                  </div>
                </div>

                <!-- Address provinces -->
                <div class="row">
                  <div class="col pt-3">
                    <label for="addressProvince">{{ $t('message.business.contact_province') }}<span class="text-danger">*</span></label>
                    <div class="select-jumbo mb-3">
                      <select v-model="submitData.address_province_id"
                              :class="{'form-alert': errors.has('addressProvince')}"
                              v-validate="'required'"
                              id="addressProvince"
                              name="addressProvince">
                        <option :value="null">{{ $t('message.booking.contact_step.set_province') }}</option>
                        <option :value="addressProvince.id" v-for="addressProvince, index in sortedProvinces">
                          {{ addressProvince | multiLangName }}
                        </option>
                      </select>
                    </div>
                    <div class="mt-1 text-remark -status-alert" v-if="errors.has('addressProvince')">
                      {{ $t('message.required_field') }}
                    </div>
                  </div>
                </div>

                <!-- Districts and sub-districts -->
                <div class="row">
                  <div class="col-6 pr-2">
                    <label for="district">{{ $t('message.booking.contact_step.district') }}<span class="text-danger">*</span></label>
                    <div class="select-jumbo">
                      <select v-model="submitData.district_id"
                              :class="{'form-alert': errors.has('district')}"
                              v-validate="'required'"
                              id="district"
                              name="district">
                        <option :value="null">{{ $t('message.booking.contact_step.set_district') }}</option>
                        <option :value="district.id" v-for="district, index in sortedDistricts">
                          {{ district | multiLangName }}
                        </option>
                      </select>
                    </div>
                    <div class="mt-1 text-remark -status-alert" v-if="errors.has('district')">
                      {{ $t('message.required_field') }}
                    </div>
                  </div>
                  <div class="col-6 pl-2">
                    <label for="sub-district">{{ $t('message.booking.contact_step.sub_district') }}</label>
                    <div class="select-jumbo">
                      <select v-model="submitData.sub_district_id" id="sub-district">
                        <option :value="null">{{ $t('message.booking.contact_step.set_sub_district') }}</option>
                        <option :value="subDistrcict.id" v-for="subDistrcict, index in sortedSubDistricts">
                          {{ subDistrcict | multiLangName }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row pt-3">
                  <div class="col">
                    <hr>
                  </div>
                </div>

                <!-- Attach photos -->
                <div class="row py-3">
                  <div class="col">
                    <h4 class="pb-2">
                      <i class="fal fa-images fa-lg"></i>&nbsp;&nbsp;{{ $t('message.service_request.big_cleaning_attach_photos') }}
                      <span class="text-danger" v-if="errorNoUploadPhoto">
                        <i class="fa fa-exclamation-circle"></i>
                      </span>
                    </h4>
                    <div class="text-remark mb-2">
                      <i class="fas fa-circle fa-sm -status-pending"></i>&nbsp;
                      {{ (submitData.service_id === 49) ? $t('message.service_request.upholstery_cleaning_attach_photos_remark') : $t('message.service_request.big_cleaning_attach_photos_remark') }}
                    </div>
                    
                    <vue-dropzone ref="vueDropzone"
                                  id="dropzone"
                                  class="dropzone-dashed"
                                  :options="dropzoneOptions"
                                  @vdropzone-file-added="clearFileUploadError"/>
                    <div class="mt-2 text-remark -status-alert" v-if="errorNoUploadPhoto">
                      {{ $t('message.required_photo_attachment') }}
                    </div>
                  </div>
                </div>

                <!-- Remark -->
                <div class="row pt-3">
                  <div class="col">
                    <h4 class="pb-2">{{ $t('message.service_request.big_cleaning_remark') }}</h4>
                    <textarea rows="2"
                              ref="remark"
                              id="remark"
                              :placeholder="$i18n.t('message.service_request.big_cleaning_remark_placeholder')"
                              class="form-control textarea-jumbo"
                              v-model="submitData.remark"/>
                  </div>
                </div>

                <div class="row pt-3">
                  <div class="col">
                    <hr>
                  </div>
                </div>

                <div class="row py-3">
                  <div class="col">
                    <h4 class="pb-2 text-orange">{{ $t('message.service_request.service_request_condition_title')
                      }}</h4>
                    <ul class="list-unstyled">
                      <li class="pb-3">
                        <i class="fas fa-circle fa-xs -status-pending"></i>&nbsp;{{
                          $t('message.service_request.service_request_remark01') }}
                      </li>
                      <li class="pb-3">
                        <i class="fas fa-circle fa-xs -status-pending"></i>&nbsp;{{
                          $t('message.service_request.service_request_remark02') }}
                      </li>
                      <li>
                        <i class="fas fa-circle fa-xs -status-pending"></i>&nbsp;{{ (submitData.service_id === 49) ? $t('message.service_request.service_request_remark04') : $t('message.service_request.service_request_remark03') }}
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="row">
                  <div class="col text-center">
                    <button class="btn btn-lg btn-info btn-block -cyan"
                            :disabled="isSubmitting"
                            @click="submitRequest()">
                      {{ isSubmitting ? $t('message.button.loading') : $t('message.button.submit_request') }}
                    </button>
                    <div class="pt-4">
                      <a href="" @click.prevent="backToFirstStep()">
                        <i class="fas fa-angle-left"></i> {{ $t('message.button.back') }}
                      </a>
                    </div>
                  </div>
                </div>
              </section>
              <!-- End form Step 2 -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-padding d-none d-lg-block" v-if="service">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-md-8 col-12">
            <h2 class="text-center">{{ $t('message.big_cleaning.service_detail') }}</h2>
            <div v-html="($i18n.locale === 'th') ? service.detail_th : service.detail_en"></div>
          </div>
        </div>
      </div>
    </section>

  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import moment from 'moment-timezone'
import axios from 'axios'
import userEventLogHelpers from '../../helpers/userEventLogHelpers'
import insiderHelpers from '../../helpers/insiderHelpers'

export default {
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      service: null,
      step: 1,
      sortBy: (this.$i18n.locale === 'th') ? 'name_th' : 'name_en',
      displayBuildingType: true,
      errorNoUploadPhoto: false,
      submitData: {
        service_id: (this.$route.query.service_id) ? Number(this.$route.query.service_id) : 13,
        service_request_purpose_id: null,
        service_date: null,
        service_time: '07:00',
        building_type_id: 1,
        building_size: null,
        building_address: null,
        address_province_id: null,
        district_id: null,
        sub_district_id: null,
        remark: null,
        tel: null
      },
      calendarData: {
        date: null,
        isToday: false
      },
      dropzoneOptions: {
        acceptedFiles: 'image/*',
        url: 'https://beneat.co',
        thumbnailWidth: 160,
        thumbnailHeight: 160,
        maxFilesize: 5,
        dictDefaultMessage: `<i class="fal fa-cloud-upload"></i> ${this.$i18n.t('message.button.upload_photos')}`,
        headers: { 'Content-Type': 'multipart/form-data' },
        addRemoveLinks: true,
        autoProcessQueue: false,
        maxFiles: 20
      },
      experience: null,
      isSubmitting: false
    }
  },
  computed: {
    ...mapGetters({
      globalState: 'globalVal/getState',
      user: 'auth/getUser'
    }),
    ...mapState('auth', ['isLineLoggedIn']),
    ...mapState('serviceRequest', ['bookingData']),
    ...mapState('addressProvince', ['addressProvinces', 'districts', 'subDistricts']),
    sortedProvinces () {
      return this._.orderBy(this.addressProvinces, [this.sortBy], ['asc'])
    },
    sortedDistricts () {
      return this._.orderBy(this.districts, [this.sortBy], ['asc'])
    },
    sortedSubDistricts () {
      return this._.orderBy(this.subDistricts, [this.sortBy], ['asc'])
    },
    serviceRequestPurposes () {
      let items = null
      if (Number(this.$route.query.service_id) === 13) {
        items = this.globalState.configData.big_cleaning_types
      } else if (Number(this.$route.query.service_id) === 49) {
        items = this.globalState.configData.upholstery_cleaning_types
      }
      return items
    }
  },
  watch: {
    $route (to, from) {
      this.checkCurrentStep()
    },
    step () {
      this.$emit('updateStep', this.step)
    },
    'user': function (newVal, oldVal) {
      if (oldVal === null && newVal) {
        this.goToSecondStep()
      }
      if (this.user.tel) {
        this.submitData.tel = this.user.tel
      }
    },
    'calendarData.date': function () {
      this.submitData.service_date = moment(this.calendarData.date, 'DD/MM/YYYY').format('YYYY-MM-DD')
    },
    'submitData.address_province_id': function (newVal, oldVal) {
      this.fetchDistricts(this.submitData.address_province_id)
    },
    'submitData.district_id': function () {
      this.fetchSubDistricts(this.submitData.district_id)
    }
  },
  methods: {
    async backToFirstStep () {
      const query = Object.assign({}, this.$route.query)
      query.step = 1
      await this.$router.push({ query })
    },
    showPicture (professional) {
      if (professional && professional.picture) {
        return professional.picture
      } else {
        return '/static/img/unknown.png'
      }
    },
    checkCurrentStep () {
      if (this.$route.query.step) {
        this.step = Number(this.$route.query.step)
      } else {
        this.step = 1
      }
    },
    setFormData () {
      if (this.bookingData) {
        this.submitData.service_request_purpose_id = this.bookingData.service_request_purpose_id
        this.submitData.service_date = this.bookingData.service_date
        this.submitData.service_time = this.bookingData.service_time
        this.submitData.building_type_id = this.bookingData.building_type_id
        this.submitData.building_size = this.bookingData.building_size
        this.calendarData.date = moment(this.bookingData.service_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
      } else {
        this.submitData.service_request_purpose_id = 1
        if (this.serviceRequestPurposes) {
          this.submitData.service_request_purpose_id = this.serviceRequestPurposes[0].id
        }
        this.submitData.service_date = moment(this.calendarData.date, 'DD/MM/YYYY').format('YYYY-MM-DD')
        this.submitData.service_time = '07:00'
        this.submitData.building_type_id = 1
        // Upholstery cleaning (building_type_id = 0)
        if (Number(this.$route.query.service_id) === 49) {
          this.submitData.building_type_id = 0
        }
        this.submitData.building_size = null
      }
    },
    saveFirstStepData () {
      this.clearData()
      let serviceDate = moment(this.calendarData.date, 'DD/MM/YYYY').format('YYYY-MM-DD')
      const bookingData = {
        service_request_purpose_id: this.submitData.service_request_purpose_id,
        service_date: serviceDate,
        service_time: this.submitData.service_time,
        building_type_id: this.submitData.building_type_id,
        building_size: this.submitData.building_size,
        expire: moment().add(3, 'hours')
      }
      this.$store.commit('serviceRequest/SET_BOOKING_DATA', bookingData)
    },
    goToSecondStep () {
      let url = `/service-requests/booking?service_id=${this.submitData.service_id}&step=2`
      if (this.$route.query.experience_id && this.experience) {
        url += `&experience_id=${this.experience.id}`
      }

      if (this.$route.query.admin_id) {
        url += `&admin_id=${this.$route.query.admin_id}`
      }

      this.$router.push(url)
    },
    nextStep () {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.saveFirstStepData()
          if (!this.user) {
            this.$parent.openModal('login')
          } else {
            this.goToSecondStep()
          }
        }
      })
    },
    fetchAddressProvinces () {
      this.$store.dispatch('addressProvince/LOAD_ADDRESS_PROVINCES')
    },
    fetchDistricts (provinceId) {
      if (provinceId) {
        const queryData = {
          province_id: provinceId
        }
        this.$store.dispatch('addressProvince/LOAD_DISTRICTS', queryData)
      }
    },
    fetchSubDistricts (districtId) {
      if (districtId) {
        const queryData = {
          district_id: districtId
        }
        this.$store.dispatch('addressProvince/LOAD_SUB_DISTRICTS', queryData)
      }
    },
    displayConfirmDialog () {
      this.$swal({
        title: this.$i18n.t('message.service_request.service_request_confirm_dialog_title'),
        text: this.$i18n.t('message.service_request.service_request_confirm_dialog_message'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#9E9E9E',
        reverseButtons: true,
        confirmButtonText: this.$i18n.t('message.button.confirm'),
        cancelButtonText: this.$i18n.t('message.button.cancel')
      }).then(() => {
        this.addServiceRequest()
      })
    },
    submitRequest () {
      this.$validator.validate().then(valid => {
        this.errorNoUploadPhoto = (this.$refs.vueDropzone.getQueuedFiles().length === 0)
        if (valid && !this.errorNoUploadPhoto) {
          this.displayConfirmDialog()
        }
      })
    },
    addServiceRequest () {
      this.isSubmitting = true
      let serviceDate = this.submitData.service_date + ' ' + this.submitData.service_time
      let formData = new FormData()
      formData.append('user_id', this.user.id)
      formData.append('tel', this.submitData.tel)
      formData.append('service_id', this.submitData.service_id)
      formData.append('service_date', serviceDate)
      formData.append('service_request_purpose_id', this.submitData.service_request_purpose_id)
      formData.append('building_type_id', this.submitData.building_type_id)
      formData.append('building_size', this.submitData.building_size)
      formData.append('building_address', this.submitData.building_address)
      formData.append('address_province_id', this.submitData.address_province_id)
      formData.append('district_id', this.submitData.district_id)
      formData.append('language', this.$i18n.locale)
      formData.append('platform', 'website')
      formData.append('add_order', true)

      if (this.$route.query.admin_id) {
        formData.append('admin_id', this.$route.query.admin_id)
      }

      if (this.submitData.remark) {
        formData.append('remark', this.submitData.remark)
      }

      if (this.submitData.sub_district_id) {
        formData.append('sub_district_id', this.submitData.sub_district_id)
      }

      if ((this.$route.query.experience_id && this.experience) && (Number(this.$route.query.experience_id) === this.experience.id)) {
        formData.append('experience_id', this.experience.id)
      }

      // Prepare file uploads
      const queueFiles = this.$refs.vueDropzone.getQueuedFiles()
      for (let key in queueFiles) {
        formData.append('upload_image[]', queueFiles[key])
      }

      // Display the key/value pairs
      for (let pair of formData.entries()) {
        console.log(pair[0] + ', ' + pair[1])
      }

      // Insider event: submit service request
      insiderHelpers.submitServiceRequestEvent(this.user, {
        serviceId: this.submitData.service_id,
        serviceRequestPurposeId: this.submitData.service_request_purpose_id,
        serviceDate: this.submitData.service_date,
        serviceTime: this.submitData.service_time,
        buildingTypeId: this.submitData.building_type_id,
        buildingSize: this.submitData.building_size,
        customerName: this.user.name,
        customerPhone: this.user.tel,
        customerAddress: this.submitData.building_address
      })

      // POST data
      this.clearData()
      let url = '/service-requests'
      axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then((res) => {
          this.isSubmitting = false
          const response = res.data
          if (!response.error) {
            const serviceRequest = response.service_request
            // Save user event log
            userEventLogHelpers.logEvent('finish_service_request', {
              service_request_id: serviceRequest.id
            })
            this.displayCompleteDialog(serviceRequest.id)
          } else {
            this.$swal({ text: 'Error:' + response.message, type: 'error' })
          }
        })
        .catch((error) => {
          this.isSubmitting = false
          console.log(error)
        })
    },
    displayCompleteDialog (serviceRequestId) {
      this.$swal({
        title: this.$i18n.t('message.success'),
        text: this.$i18n.t('message.service_request.success_message'),
        type: 'success',
        confirmButtonText: this.$i18n.t('message.service_request.see_request_detail')
      }).then((result) => {
        if (result) {
          const page = `/service-requests/${serviceRequestId}`
          this.$router.push(page)
        }
      })
    },
    clearData () {
      this.$store.commit('serviceRequest/SET_BOOKING_DATA', null)
    },
    getService (services, id) {
      let service = null
      for (let key in services) {
        const item = services[key]
        if (item.id === id) {
          service = item
          break
        }
      }
      return service
    },
    async getExperience (id) {
      const { data } = await axios.get('experiences/' + id)
      if (!data.error) {
        this.experience = data
      }
    },
    clearFileUploadError (file) {
      this.errorNoUploadPhoto = false
    }
  },
  mounted () {
    this.calendarData.date = moment().format('DD/MM/YYYY')
    const currentTime = moment()
    if (this.bookingData && currentTime.isAfter(this.bookingData.expire)) {
      this.clearData()
      if (this.$route.query.step) {
        this.$router.push('/service-requests/booking')
      }
    }
    if (this.submitData.service_id === 49) {
      this.displayBuildingType = false
    }
    // Set default for big cleaning service
    this.service = this.getService(this.globalState.services, this.submitData.service_id)
    // Check user phone
    if (this.user && this.user.tel) {
      this.submitData.tel = this.user.tel
    }
    this.checkCurrentStep()
    this.setFormData()
    this.fetchAddressProvinces()
    // Save user event log
    userEventLogHelpers.logEvent('begin_service_request', {
      service_id: this.submitData.service_id
    })
    // Insider service request view event
    insiderHelpers.serviceRequestPageViewEvent(this.user, this.submitData.service_id)
  },
  created () {
    if (this.$route.query.experience_id) {
      this.getExperience(this.$route.query.experience_id)
    } else {
      this.experience = null
    }
    if (!this.$route.query.step) {
      this.$store.commit('serviceRequest/SET_BOOKING_DATA', null)
    }
  }
}
</script>

<style scoped>
.input-text-icon {
  float: right;
  margin-right: 1rem;
  margin-top: -2.15rem;
  position: relative;
  font-size: 120%;
  z-index: 2;
  color: #9E9E9E;
}
div >>> ul li {
  margin-left: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/serviceRequest/Booking.vue